import { RArray } from "../../collections";
import { makeImmutable } from "../../core/makeImmutable";
export class PromotionSolverVariableAssignment {
    constructor(params) {
        this.promotionAssociations = params.promotionAssociations;
        makeImmutable(this);
    }
    get variableCount() {
        return this.promotionAssociations.reduce((acc, promotionAssociation) => {
            switch (promotionAssociation.kind) {
                case "Product":
                    return acc + promotionAssociation.matchingProducts.size;
                case "WholeOrder":
                    return acc + 1;
            }
        }, 0);
    }
    get byPromotion() {
        let variableAccumulator = 0;
        return this.promotionAssociations.map((promotionAssociation) => {
            const variables = promotionAssociation.kind === "Product"
                ? RArray.range(promotionAssociation.matchingProducts.size).map((v) => variableAccumulator + v)
                : RArray.singleton(variableAccumulator);
            variableAccumulator += variables.size;
            return [promotionAssociation.promotionTypeId, variables];
        });
    }
    get byVariable() {
        return this.promotionAssociations.flatMap((promotionAssociation) => {
            return promotionAssociation.kind === "Product"
                ? promotionAssociation.matchingProducts.map((orderLineReference) => [
                    promotionAssociation.promotionTypeId,
                    orderLineReference,
                ])
                : RArray.singleton([promotionAssociation.promotionTypeId, null]);
        });
    }
}
